import { render, staticRenderFns } from "./RingSolutionsRedirectDialog.vue?vue&type=template&id=8dd9405c&scoped=true&"
import script from "./RingSolutionsRedirectDialog.vue?vue&type=script&lang=js&"
export * from "./RingSolutionsRedirectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd9405c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dd9405c')) {
      api.createRecord('8dd9405c', component.options)
    } else {
      api.reload('8dd9405c', component.options)
    }
    module.hot.accept("./RingSolutionsRedirectDialog.vue?vue&type=template&id=8dd9405c&scoped=true&", function () {
      api.rerender('8dd9405c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Core/RingSolutionsRedirectDialog.vue"
export default component.exports